import React from "react"
import { func, string } from "prop-types";
import styled from "styled-components"


const PoolPanelTitle = styled.div`
  font-size: 2rem;
  text-align:left;
  align-self:center;
  justify-content: center;


  /* Mobiles */
  @media (max-width: 640px) {
    font-size: 1.5rem;
  }
`;

export default PoolPanelTitle;